/* ============================================================================
   xa-about-fade.js — light scroll-triggered fade-in for the About page
   - Adds .xa-fade / .xa-fade-child to target elements after DOM ready
   - One IntersectionObserver tracks them; element is unobserved on first hit
   - Children of stagger groups get a per-index transition-delay for cascade
   - prefers-reduced-motion users skip animation entirely
   - Twin of assets/xa-top-fade.js, scoped to xa-about sections
============================================================================ */
(function () {
  'use strict';
  if (window.__xaAboutFadeInit) return;
  window.__xaAboutFadeInit = true;

  if (window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    return;
  }

  // Single elements that fade as one block (section heads, body copy, etc.)
  var FADE_TARGETS = [
    '.xa-about-section .xa-tag',
    '.xa-about-section .xa-h2',
    '.xa-about-section .xa-h3',
    '.xa-about-section .xa-subtitle',
    '.xa-about-section .xa-body',
    '.xa-about-section .xa-body-sm',
    '.xa-about-section .xa-about-cta__heading',
    '.xa-about-section .xa-about-cta__body'
  ];

  // Containers whose direct children fade in with a staggered delay (ms).
  var STAGGER_GROUPS = [
    { selector: '.xa-purpose-list',          stride: 100 },
    { selector: '.xa-about-services .xa-services-cards', stride: 80 },
    { selector: '.xa-brandos-layers',        stride: 70  },
    { selector: '.xa-partners-categories',   stride: 100 },
    { selector: '.xa-partners-logo-grid',    stride: 40  },
    { selector: '.xa-alliance-grid',         stride: 50  },
    { selector: '.xa-about-company__table',  stride: 60  }
  ];

  function init() {
    var watched = [];

    FADE_TARGETS.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        el.classList.add('xa-fade');
        watched.push(el);
      });
    });

    STAGGER_GROUPS.forEach(function (group) {
      document.querySelectorAll(group.selector).forEach(function (parent) {
        var children = parent.children;
        for (var i = 0; i < children.length; i++) {
          var child = children[i];
          child.classList.add('xa-fade-child');
          child.style.transitionDelay = (i * group.stride) + 'ms';
          watched.push(child);
        }
      });
    });

    if (!('IntersectionObserver' in window) || watched.length === 0) {
      watched.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);
      });
    }, {
      rootMargin: '0px 0px -8% 0px',
      threshold: 0.05
    });

    watched.forEach(function (el) { io.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
